import { getCoreRowModel, useReactTable } from '@/libs/table'
import type { ColumnDef, Table, VisibilityState } from '@/libs/table'
import { useState } from 'react'

type Options<TData> = {
	data: TData[]
	columns: ColumnDef<TData, unknown>[]
	getRowId: (row: TData) => string
	meta?: Record<string, unknown>
}

type Result<TData> = {
	table: Table<TData>
	columnVisibility: VisibilityState
	setColumnVisibility: (state: VisibilityState) => void
}

const useDataTable = <TData>({ data, columns, getRowId, meta }: Options<TData>): Result<TData> => {
	const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({})
	const [columnSizing, setColumnSizing] = useState({})

	const table = useReactTable({
		data,
		columns,
		getRowId,
		getCoreRowModel: getCoreRowModel(),
		enableColumnResizing: true,
		columnResizeMode: 'onChange',
		onColumnVisibilityChange: updater => {
			setColumnVisibility(prev => (typeof updater === 'function' ? updater(prev) : updater))
		},
		onColumnSizingChange: setColumnSizing,
		state: { columnVisibility, columnSizing },
		meta,
	})

	return { table, columnVisibility, setColumnVisibility }
}

export { useDataTable }
